<template>
	<div class="class-list-card" @click="handleClick">
		<img :src="data.thumbnail_url" class="class-list-img-dd" />
		<div class="class-list-content">
			<div style="height: 45px;">
				<h3 class="name-class">
					{{ data.name }}
				</h3>
			</div>
			<div class="info-dev mb-2">
				<div style="background-color: #f1f6ff" v-if="data.level">
					<p>{{ data.level }}</p>
				</div>
			</div>
			<div class="event-ctn-info" v-if="data.session">
                <NoteIcon :width="25" fill="#575966" />
                <span class="name">{{ data.session }} {{ $t('home.a2') }}</span>
              </div>
              <div class="event-ctn-info" v-if="activeTab != 'Event'">
                <AwardIcon :width="25" fill="#575966" />
                <span class="name">Reguler / Private</span>
              </div>
              <div class="event-ctn-info" v-if="data.days">
                <DateIcon :width="25" fill="#575966" />
                <span class="name">{{ data.days }}</span>
              </div>
              <div class="event-ctn-info" v-if="data.hours">
                <clock :width="25" fill="#575966" />
                <span class="name">{{ data.hours }}</span>
              </div>
              <div class="event-ctn-info" v-if="data.method">
                <methode :width="25" fill="#575966" />
                <span class="name">{{ data.method | toMethode }}</span>
              </div>
		</div>
	</div>
</template>

<script>
import DateIcon from "../../home/icons/Date.vue";
import Clock from "../../home/icons/Clock.vue";
import Methode from "../../home/icons/Methode.vue";
import NoteIcon from '@/assets/icons/Note.vue';
import AwardIcon from '@/assets/icons/Award.vue';

export default {
	name: 'CardClassPublicTrainingComponenet',
	props: {
		data: {
			type: Object,
			required: true,
		},
		onClick: {
			type: Function,
			required: false,
		},
	},
	components: {
		NoteIcon,
		AwardIcon,
		DateIcon,
		Clock,
		Methode,
	},
	methods: {
		handleClick() {
			this.onClick(this.data.slug_name);
		},
	},
};
</script>

<style src="./css/cardClass.css" scoped></style>
